// Generated by packages/ui/scripts/build-app-sprite.mjs - do not edit manually

import type { SpriteIconProps } from '@repo/ui/Icons';
import { SpriteIcon } from '@repo/ui/Icons';

import { spriteUrl } from './sprite.generated';

export type IconProps = Omit<SpriteIconProps, 'spriteUrl'>;

export function Icon(props: IconProps) {
  return <SpriteIcon {...props} spriteUrl={spriteUrl} />;
}
